"use client";

export default function SiteFooter() {
  return (
    <footer className="border-t border-zinc-800/60 mt-16">
      <div className="w-full max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-12 2xl:px-16 py-8">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          {/* Brand */}
          <div>
            <p className="text-zinc-400 text-sm font-semibold mb-1">
              DevError<span className="text-cyan-400">Explainer</span>
            </p>
            <p className="text-zinc-600 text-xs max-w-xs leading-5">
              AI-powered error message explanations for developers. Paste, select, understand.
            </p>
          </div>

          {/* SEO Error Pages */}
          <div>
            <p className="text-zinc-600 text-xs uppercase tracking-wide font-medium mb-2">Error Reference</p>
            <div className="grid grid-cols-2 gap-x-8 gap-y-1">
              {[
                { label: "PHP: Undefined Index", href: "/errors/php/undefined-index" },
                { label: "JS: TypeError", href: "/errors/javascript/typeerror-cannot-read-property" },
                { label: "Python: IndexError", href: "/errors/python/indexerror-list-index-out-of-range" },
                { label: "Java: NullPointerException", href: "/errors/java/nullpointerexception" },
              ]?.map((link) => (
                <a
                  key={link?.href}
                  href={link?.href}
                  className="text-xs text-zinc-600 hover:text-cyan-400 transition-colors"
                >
                  {link?.label}
                </a>
              ))}
            </div>
          </div>

          {/* Meta */}
          <div className="text-right">
            <p className="text-zinc-700 text-xs" style={{ fontFamily: "'IBM Plex Mono', monospace" }}>
              v1.0.0 · March 2026
            </p>
            <p className="text-zinc-700 text-xs mt-1">
              Built for developers, by developers
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}